import { withTranslation } from 'react-i18next'

import { CURRENCY } from '@/lib/consts'
import Button from '@/ui/Button'
import LazyImage from '@/ui/LazyImage'

import {
  CartItemActions,
  CartItemCaption,
  CartItemContent,
  CartItemImage,
  CartItemPrice,
  CartItemPriceQty,
  CartItemPriceValue,
  CartItemTitle,
  CartItemWrapper
} from './CartItem.styles'

const CartItem = ({ t, name, additionalInfo, totalAmount, quantity, price, onEdit, onRemove, variants, additions, imageUrl }) => {
  return (
    <CartItemWrapper>
      <CartItemImage>
        <LazyImage src={imageUrl} />
      </CartItemImage>
      <CartItemContent>
        <CartItemTitle>{name}</CartItemTitle>
        {additionalInfo && <CartItemCaption>{additionalInfo}</CartItemCaption>}
        <CartItemActions>
          <Button icon="edit" size="sm" variant="secondary" onClick={onEdit} addRightMargin={true}>
            {t('edit')}
          </Button>
          <Button icon="trash" size="sm" variant="tertiary" onClick={onRemove}>
            {t('remove')}
          </Button>
        </CartItemActions>
      </CartItemContent>
      <CartItemPrice>
        <CartItemPriceQty>{quantity}x</CartItemPriceQty>
        <CartItemPriceValue>
          {(totalAmount || price).toFixed(2)} {CURRENCY}
        </CartItemPriceValue>
      </CartItemPrice>
    </CartItemWrapper>
  )
}

export default withTranslation()(CartItem)
